import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const en = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Ladda ner data</b>
        </p>
        <p>
          För att ladda ner dina data, gå till följande sida
          <br />
          Inställningar {'>'} Alternativ {'>'} Datahantering {'>'} Ladda ner
          data
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Begär radering av data</b>
    </p>
    <br />
    <p>Följ stegen nedan för att begära radering av data:</p>
    <br />
    <p>
      1. Gå till{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Kontakta oss -sidan
      </UrlLink>
      <br />
      2. Välj alternativet "Ta bort konto och alla mina data"
      <br />
      3. Fyll i formuläret och tryck på "Skicka meddelande" <br />
      <br />
    </p>
    <p>Vårt CS -team kommer att radera all din data inom 24 timmar.</p>
  </div>
);

export default en;
